<template>
	<a href="javascript: void(0)" :style="{ '--color': color }" class="A" :disabled="disabled" @click="onClick" @mouseenter="!disabled && $emit('mouseenter', $event)" @mouseover="!disabled && $emit('mouseover', $event)" v-bind="$attrs" v-on="_listeners">
		<slot></slot>
	</a>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'inherit',
		},
	},
	methods: {
		onClick(event) {
			!this.disabled && this.$emit('click', event);
		}
	},
	computed: {
		_listeners() {
			const { click, mouseover, ...rest } = this.$listeners;
			return rest;
		},
	},
};
</script>

<style scoped lang="scss">
a {
	color: var(--color);
	display: inline-block;
	transition: all .2s;

	&[disabled] {
		cursor: not-allowed;
		filter: saturate(0);
		opacity: 0.5;
	}
}
</style>
